import { render, staticRenderFns } from "./Simcard.vue?vue&type=template&id=33085710&"
import script from "./Simcard.vue?vue&type=script&lang=js&"
export * from "./Simcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports